// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v14lG","index":"styles_index__3Hd57"};